import { useApiBase } from './useApiBase'

export interface CreateConsultRequest {
  letterBody?: string
}

export interface CreateConsultResponse {
  consultId: string
  snapshotProjectId: string
}

export function useConsultApi() {
  const { apiBase, authenticatedFetch } = useApiBase()

  const createConsult = async (projectId: string, request?: CreateConsultRequest) => {
    return authenticatedFetch<CreateConsultResponse>(
      `${apiBase}/api/v1/projects/${projectId}/consult`,
      {
        method: 'POST',
        body: JSON.stringify(request ?? {}),
      },
    )
  }

  return { createConsult }
}
